export default __webpack_public_path__ + "static/media/recording-download-icon.562e9c44.svg";